import { MappingDependency } from './mapping-dependency';
import { MappingStructure } from './mapping-structure';
import { MappingBase } from './mapping-base';

export class Mapping extends MappingBase {
    isDefault: boolean;

    month?: Date;
    notMapped: MappingDependency[];
    structure: MappingStructure[];

    constructor(label: string, description: string, isDefault: boolean) {
        super(label, description);

        this.isDefault = isDefault;

        this.notMapped = [];
        this.structure = [];
    }
}
